export function stopAllTracks(this: any) {
  if (this.mediaStream) {
    this.mediaStream.getTracks().forEach((track) => {
      track.stop();
    });
  }
}
